import type { IconSvgObject } from './types';

const ExpandIcon: IconSvgObject = [
  ["path", { d: "M19 12L18.9999 5.99999C18.9999 5.44771 18.5522 5 17.9999 5L12 5.00003", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 12L5.00005 18C5.00006 18.5523 5.44777 19 6.00006 19L12 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ExpandIcon;
